module.exports = __webpack_public_path__ + "media/widget/search-baa19158.svg";